export default __webpack_public_path__ + "static/media/eye-blue.f2c70ee2.svg";